import { defineMessages } from 'react-intl';

export default defineMessages({
    unableToReassign: {
        id: 'gateway.directives.reassign-activity.Unable to reassign',
        defaultMessage: 'Unable to reassign',
    },
});
